import React from 'react';
import PropTypes from 'prop-types';
import { LazyLoadComponent } from 'react-lazy-load-image-component';

import IconSvg from 'components/Core/IconSvg';

import { ActivityCardBg as ActivityCardBgElem, LabelWrap, Overlay } from './ActivityCard.styles';

const ActivityCard = (props) => {
  const {
    title,
    areaChoiceDisplay: areaChoice,
    background,
    theme: { icon: themeIcon },
  } = props;
  return (
    <LazyLoadComponent>
      <ActivityCardBgElem {...background} className="w-full h-full bg-center bg-no-repeat bg-cover rounded-base group">
        {/* TODO: Replace Overlay with core overlay component */}
        <Overlay>
          <div className="text-white p-4">
            <div className="w-full mb-4">
              <div className="lg:hidden">
                <h5 className="uppercase font-medium text-xs">{areaChoice}</h5>
                <h3 className="font-black tracking-tight">{title}</h3>
              </div>

              <div className="hidden lg:block">
                <h5 className="uppercase font-normal">{areaChoice}</h5>
                <h3 className="hyphenate tracking-normal">{title}</h3>
              </div>
            </div>
            <div className="w-full flex md:my-4">
              <LabelWrap themeIcon={themeIcon}>
                <IconSvg icon={themeIcon} size={22} className="mx-auto lg:hidden" />
                <IconSvg icon={themeIcon} size={32} className="mx-auto hidden lg:block" />
              </LabelWrap>
            </div>
          </div>
        </Overlay>
      </ActivityCardBgElem>
    </LazyLoadComponent>
  );
};

ActivityCard.propTypes = {
  title: PropTypes.string.isRequired,
  areaChoiceDisplay: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  theme: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }).isRequired,
  background: PropTypes.shape({
    image: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default ActivityCard;
